module.exports = __webpack_public_path__ + "static/media/s3.eb53100a.webp";